export var isUndefined = function isUndefined(comp) {
  return comp === undefined;
};